import { Button, Flex, Modal, Select, Tooltip } from 'antd';
import React, { useContext, useState } from 'react';
import { FaExchangeAlt, FaUndo } from 'react-icons/fa';
import { AuthContext } from 'src/AuthProvider';
import { useChangeOrganizationMutation, useGetOrganizationsQuery } from 'src/redux/services/centralApi';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

export default function ChangeOrganization() {
	const navigate = useNavigate();
	const { updateAuthData, user, refreshToken, } = useContext(AuthContext);

	const {
		data: organizationsData,
		isLoading: isLoadingOrganizations,
	} = useGetOrganizationsQuery();

	const superToken = Cookies.get('intraguard.super_token');
	const isSuper = !!superToken;

	const [ mutate, mutateStatus, ] = useChangeOrganizationMutation();

	const [ open, setOpen, ] = useState<boolean>(false);
	const [ orgId, setOrgId, ] = useState<string>();

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	if (!isSuper) return <></>;

	return (
		<>
			<Tooltip title='Impersonar organização'>
				<Button type='text' icon={<FaExchangeAlt color='#FFF' />} onClick={handleOpen} />
			</Tooltip>
			<Modal
				open={open}
				onCancel={handleClose}
				confirmLoading={mutateStatus.isLoading}
				title='Impersonar organização'
				onOk={() => {
					if (orgId) {
						mutate({ orgId, })
							.unwrap()
							.then((response) => {
								//@ts-ignore
								if (response?.payload?.token && response?.payload?.user) {
									//@ts-ignore
									const user = response.payload.user;
									//@ts-ignore
									const token = response.payload.token;
									updateAuthData(token, user);
									navigate('/');
								}
							})
							.catch((error) => {
								if(error.data.frontend_message){
									toast.error(error.data.frontend_message);
									return;
								}
								
								console.error('Erro ao Impersonar organização:', error);
							})
							.finally(() => handleClose());
					}
				}}
			>
				<Flex gap={4}>
					<Select
						defaultValue={user?.org_id}
						placeholder='Selecionar organização'
						options={organizationsData?.map(el => ({ label: el.name, value: el.id, }))}
						style={{ width: '100%', }}
						onChange={(value) => setOrgId(value)}
						loading={isLoadingOrganizations}
					/>
					{
						user?.org_id && (
							<Button
								onClick={refreshToken}
								type='text'
								icon={<FaUndo />}
							/>
						)
					}
				</Flex>
			</Modal>
		</>
	);
}
